var _desc, _defs, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyPromiseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0.281307727,
    x2: 0.136643425,
    y2: 0,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19533889,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3564453,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0.00527871633,
    x2: 0.5,
    y2: 1,
    id: "gradient_2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.945123255,
    y1: 0.837378561,
    x2: 0.196413919,
    y2: 0.04632213,
    id: "gradient_3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62EBB9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "objectBoundingBox",
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.23515%",
    gradientTransform: "translate(0.5,0.5),scale(0.0625,1),rotate(90),scale(1,16.54227),translate(-0.5,-0.5)",
    id: "gradient_4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "objectBoundingBox",
    cx: "48.91554%",
    cy: "50.93844%",
    fx: "48.91554%",
    fy: "50.93844%",
    r: "48.23515%",
    gradientTransform: "translate(0.4891554,0.5093844),scale(0.09375,1),rotate(90),scale(1,10.39014),translate(-0.4891554,-0.5093844)",
    id: "gradient_5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 12.5C11.46 12.5 14.93 13.09 16.36 14.83C17.38 13.49 18 11.82 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10C2 11.82 2.62 13.49 3.64 14.83C5.07 13.09 8.54 12.5 10 12.5ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM8.5 7.5C8.5 8.33 9.17 9 10 9C10.83 9 11.5 8.33 11.5 7.5C11.5 6.67 10.83 6 10 6C9.17 6 8.5 6.67 8.5 7.5ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.51 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28Z",
    transform: "translate(2 2)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-privacy-promise",
    transform: "translate(0.25 0.25)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19L0 29C0 39.4934 8.50659 48 19 48C29.4934 48 38 39.4934 38 29L38 19ZM8 19C8 12.9249 12.9249 8 19 8C25.0751 8 30 12.9249 30 19L30 29C30 35.0751 25.0751 40 19 40C12.9249 40 8 35.0751 8 29L8 19Z",
    transform: "translate(13 0)",
    id: "Rectangle",
    fill: "#575756",
    fillRule: "evenodd",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16L0 30C0 38.8366 7.16344 46 16 46C24.8366 46 32 38.8366 32 30L32 16ZM2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16L30 30C30 37.732 23.732 44 16 44C8.26801 44 2 37.732 2 30L2 16Z",
    transform: "translate(16 3)",
    id: "Rectangle",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L8 0L8 4L0 4L0 0Z",
    transform: "translate(13 18)",
    id: "Rectangle",
    fill: "url(#gradient_2)",
    fillOpacity: 0.5,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L8 0L8 4L0 4L0 0Z",
    transform: "translate(43 18)",
    id: "Rectangle",
    fill: "url(#gradient_2)",
    fillOpacity: 0.5,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L50 0Q50.1537 0 50.3063 0.0069945Q50.459 0.013989 50.6103 0.0279637Q50.7616 0.0419385 50.9113 0.0628649Q51.0609 0.0837914 51.2086 0.111627Q51.3563 0.139462 51.5018 0.17415Q51.6472 0.208838 51.7901 0.250307Q51.933 0.291776 52.073 0.339942Q52.2131 0.388108 52.35 0.442873Q52.4869 0.497638 52.6204 0.558889Q52.7539 0.620141 52.8837 0.687755Q53.0135 0.755368 53.1394 0.829206Q53.2653 0.903043 53.3869 0.982954Q53.5086 1.06287 53.6258 1.14869Q53.743 1.23451 53.8556 1.32606Q53.9681 1.41762 54.0757 1.51473Q54.1833 1.61183 54.2857 1.71429Q54.3882 1.81674 54.4853 1.92434Q54.5824 2.03193 54.6739 2.14445Q54.7655 2.25697 54.8513 2.37418Q54.9371 2.49139 55.017 2.61306Q55.097 2.73472 55.1708 2.86059Q55.2446 2.98646 55.3123 3.11628Q55.3799 3.2461 55.4411 3.3796Q55.5024 3.5131 55.5571 3.65001Q55.6119 3.78692 55.6601 3.92696Q55.7082 4.06701 55.7497 4.2099Q55.7912 4.35279 55.8259 4.49823Q55.8605 4.64367 55.8884 4.79138Q55.9162 4.93908 55.9371 5.08874Q55.9581 5.23839 55.972 5.3897Q55.986 5.54101 55.993 5.69367Q56 5.84632 56 6L56 30Q56 30.1537 55.993 30.3063Q55.986 30.459 55.972 30.6103Q55.9581 30.7616 55.9371 30.9113Q55.9162 31.0609 55.8884 31.2086Q55.8605 31.3563 55.8259 31.5018Q55.7912 31.6472 55.7497 31.7901Q55.7082 31.933 55.6601 32.073Q55.6119 32.2131 55.5571 32.35Q55.5024 32.4869 55.4411 32.6204Q55.3799 32.7539 55.3123 32.8837Q55.2446 33.0135 55.1708 33.1394Q55.097 33.2653 55.0171 33.3869Q54.9371 33.5086 54.8513 33.6258Q54.7655 33.743 54.6739 33.8556Q54.5824 33.9681 54.4853 34.0757Q54.3882 34.1833 54.2857 34.2857Q54.1833 34.3882 54.0757 34.4853Q53.9681 34.5824 53.8556 34.6739Q53.743 34.7655 53.6258 34.8513Q53.5086 34.9371 53.3869 35.017Q53.2653 35.097 53.1394 35.1708Q53.0135 35.2446 52.8837 35.3123Q52.7539 35.3799 52.6204 35.4411Q52.4869 35.5024 52.35 35.5571Q52.2131 35.6119 52.073 35.6601Q51.933 35.7082 51.7901 35.7497Q51.6472 35.7912 51.5018 35.8259Q51.3563 35.8605 51.2086 35.8884Q51.0609 35.9162 50.9113 35.9371Q50.7616 35.9581 50.6103 35.972Q50.459 35.986 50.3063 35.993Q50.1537 36 50 36L6 36Q5.84632 36 5.69367 35.993Q5.54101 35.986 5.3897 35.972Q5.23839 35.9581 5.08874 35.9371Q4.93908 35.9162 4.79138 35.8884Q4.64367 35.8605 4.49823 35.8259Q4.35279 35.7912 4.2099 35.7497Q4.06701 35.7082 3.92696 35.6601Q3.78692 35.6119 3.65001 35.5571Q3.5131 35.5024 3.3796 35.4411Q3.2461 35.3799 3.11628 35.3123Q2.98646 35.2446 2.86059 35.1708Q2.73472 35.097 2.61306 35.0171Q2.49139 34.9371 2.37418 34.8513Q2.25697 34.7655 2.14445 34.6739Q2.03193 34.5824 1.92434 34.4853Q1.81674 34.3882 1.71429 34.2857Q1.61183 34.1833 1.51473 34.0757Q1.41762 33.9681 1.32606 33.8556Q1.23451 33.743 1.14869 33.6258Q1.06287 33.5086 0.982954 33.3869Q0.903043 33.2653 0.829206 33.1394Q0.755368 33.0135 0.687755 32.8837Q0.620141 32.7539 0.558889 32.6204Q0.497638 32.4869 0.442873 32.35Q0.388108 32.2131 0.339942 32.073Q0.291776 31.933 0.250307 31.7901Q0.208838 31.6472 0.17415 31.5018Q0.139462 31.3563 0.111627 31.2086Q0.0837914 31.0609 0.0628649 30.9113Q0.0419385 30.7616 0.0279637 30.6103Q0.013989 30.459 0.0069945 30.3063Q0 30.1537 0 30L0 6Q0 5.84632 0.0069945 5.69367Q0.013989 5.54101 0.0279637 5.3897Q0.0419385 5.23839 0.0628649 5.08874Q0.0837914 4.93908 0.111627 4.79138Q0.139462 4.64367 0.17415 4.49823Q0.208838 4.35279 0.250307 4.2099Q0.291776 4.06701 0.339942 3.92696Q0.388108 3.78692 0.442873 3.65001Q0.497638 3.5131 0.558889 3.3796Q0.620141 3.2461 0.687755 3.11628Q0.755368 2.98646 0.829206 2.86059Q0.903043 2.73472 0.982954 2.61306Q1.06287 2.49139 1.14869 2.37418Q1.23451 2.25697 1.32606 2.14445Q1.41762 2.03193 1.51473 1.92434Q1.61183 1.81674 1.71429 1.71429Q1.81674 1.61183 1.92434 1.51473Q2.03193 1.41762 2.14445 1.32606Q2.25697 1.23451 2.37418 1.14869Q2.49139 1.06287 2.61306 0.982954Q2.73472 0.903043 2.86059 0.829206Q2.98646 0.755368 3.11628 0.687755Q3.2461 0.620141 3.3796 0.558889Q3.5131 0.497638 3.65001 0.442873Q3.78692 0.388108 3.92696 0.339942Q4.06701 0.291776 4.2099 0.250307Q4.35279 0.208838 4.49823 0.17415Q4.64367 0.139462 4.79138 0.111627Q4.93908 0.0837914 5.08874 0.0628649Q5.23839 0.0419385 5.3897 0.0279637Q5.54101 0.013989 5.69367 0.0069945Q5.84632 0 6 0Z",
    transform: "translate(4 22)",
    id: "Rectangle",
    fill: "url(#gradient_3)",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-member",
    transform: "translate(20 28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline-account_circle-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Path",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 12.5C11.46 12.5 14.93 13.09 16.36 14.83C17.38 13.49 18 11.82 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10C2 11.82 2.62 13.49 3.64 14.83C5.07 13.09 8.54 12.5 10 12.5ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM8.5 7.5C8.5 8.33 9.17 9 10 9C10.83 9 11.5 8.33 11.5 7.5C11.5 6.67 10.83 6 10 6C9.17 6 8.5 6.67 8.5 7.5ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.51 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28Z",
    transform: "translate(2 2)",
    id: "account",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Rectangle-5-Copy-7",
    fill: "#FFFFFF",
    stroke: "none"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 4C49.6731 4 64 3.10457 64 2C64 0.895431 49.6731 0 32 0C14.3269 0 0 0.895431 0 2C0 3.10457 14.3269 4 32 4Z",
    id: "shadow",
    fill: "url(#gradient_4)",
    style: {
      mixBlendMode: "multiply"
    },
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3C24.8366 3 32 2.32843 32 1.5C32 0.671573 24.8366 0 16 0C7.16344 0 0 0.671573 0 1.5C0 2.32843 7.16344 3 16 3Z",
    transform: "translate(16 0)",
    id: "shadow",
    fill: "url(#gradient_5)",
    style: {
      mixBlendMode: "multiply"
    },
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPromiseIcon);
export default __webpack_public_path__ + "static/media/privacy-promise-icon.eb0a4ebfbcaf8ccbf1cb0509569a824c.svg";
export { ForwardRef as ReactComponent };